export default {
    update: "Update",
    title: "Updates",
    columns: {
        name: "Service name",
        version: "Version",
        download: "Download Date",
        send_request_download: "Unscheduled check for updates",
        send_request_delete: "Delete all services",
    },
    notification: {
        load_error: "Load error",
        download_ok: "Request send",
        download_error: "Request error",
    },
}